// extracted by mini-css-extract-plugin
export var testimonial = "Testimonial-module--testimonial--2xEGS";
export var container = "Testimonial-module--container--1_GLp";
export var authorGrid = "Testimonial-module--author-grid--clxzI";
export var quote = "Testimonial-module--quote--zvVCQ";
export var testimonialMedium = "Testimonial-module--testimonialMedium--2dTDw";
export var author = "Testimonial-module--author--gEVtN";
export var testimonialLarge = "Testimonial-module--testimonialLarge--llTp7";
export var show = "Testimonial-module--show--2iR4V";
export var showFadeInDown = "Testimonial-module--show-fade-in-down--XFp01";
export var showFadeInUp = "Testimonial-module--show-fade-in-up--3dvIn";
export var hideFadeOut = "Testimonial-module--hide-fade-out--1TtT2";